import { ApiError } from "@responia/api/cliente";
import { Avisos } from "@responia/ui/components/aviso";
import { Senal } from "@responia/ui/components/senal";
import { Skeleton } from "@responia/ui/components/skeleton";
import { SesionProvider } from "@/sesion";
import { useError } from "@/errores";
import { Shell } from "./Shell";

function Cargando() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background" aria-busy="true">
      <div className="flex w-64 flex-col items-center gap-4">
        <Senal className="text-3xl text-encre-3" />
        <Skeleton className="h-3 w-40" />
      </div>
    </div>
  );
}

function ErrorGeneral({ codigo, ref_ }: { codigo: string; ref_?: string }) {
  const m = useError()(new ApiError(500, codigo, ref_));
  return (
    <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-2 bg-background px-4 text-center">
      <Senal className="text-3xl text-encre-3" />
      <p className="max-w-md text-lg">{m.titulo}</p>
      {m.ref && <p className="text-xs text-encre-3 tabular-nums">{m.ref}</p>}
    </div>
  );
}

export function AppLayout() {
  return (
    <SesionProvider cargando={<Cargando />} error={(codigo, ref) => <ErrorGeneral codigo={codigo} ref_={ref} />}>
      <Shell />
      <Avisos />
    </SesionProvider>
  );
}
